const REFRESH_AFTER_MS = 45 * 60_000

const seenAt = new Map<string, { url: string; firstSeenAt: number }>()

export function stableAvatarSrc(fileId: string | null | undefined, url: string | null | undefined): string | null {
  if (!url) return null
  if (!fileId) return url

  const existing = seenAt.get(fileId)
  if (existing && Date.now() - existing.firstSeenAt < REFRESH_AFTER_MS) {
    return existing.url
  }

  seenAt.set(fileId, { url, firstSeenAt: Date.now() })
  return url
}
